import "./IframeFormGroup.css";

import cx from "classnames";
import PropTypes from "prop-types";
import React from "react";

export default function IframeFormGroup({
  children,
  className,
  hasError,
  withErrorIcon,
}) {
  return (
    <div
      className={cx("iframeFormGroup", className, {
        "has-error": hasError,
        "iframeFormGroup--withoutIcon": !withErrorIcon,
      })}
    >
      {children}
      {withErrorIcon && hasError && <span className="iframeFormGroup-error" />}
    </div>
  );
}

IframeFormGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  hasError: PropTypes.bool,
  withErrorIcon: PropTypes.bool,
};

IframeFormGroup.defaultProps = {
  className: undefined,
  hasError: false,
  withErrorIcon: true,
};
